import { render, staticRenderFns } from "./labourPredictiveRisk.vue?vue&type=template&id=a136ba6e"
import script from "./labourPredictiveRisk.vue?vue&type=script&lang=js"
export * from "./labourPredictiveRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports